@if (specificConfig.showLabel) {
	<h6 class="m-0">{{ specificConfig.label }}</h6>
}

<div class="container-fluid">
	<div class="row">
		<div class="col-md-6 col-12 p-1">
			<app-multi-select
				[genericConfig]="specificConfig.subfilters.first"
				(optionChanged)="onFirstOptionChange($event)"></app-multi-select>
		</div>
		<div class="col-md-6 col-12 p-1">
			<app-multi-select
				[genericConfig]="specificConfig.subfilters.second"
				(optionChanged)="onSecondOptionChange($event)"></app-multi-select>
		</div>
	</div>
</div>

<app-modal [modal]="modal" modalId="multiSelectModal"></app-modal>
